import * as React from 'react';
import { IExtendedSearch } from '..';
import { TESSearchField } from '../definitions';
import DateRangeField from './fields/DateRangeField';
import SerologicalProfileField from './fields/SerologicalProfileField';
import MedicationField from './fields/MedicationField';
import SubstanceField from './fields/SubstanceField';
import RelapseField from './fields/RelapseField';
import LeddField from './fields/LeddField';
import TreatmentField from './fields/TreatmentField';
import DefaultField from './fields/DefaultField';
import TirednessOrNearMissWhileDrivingField from './fields/TirednessOrNearMissWhileDrivingField';
import PapDeviceField from './fields/PapDeviceField';
import PapTreatmentResponseField from './fields/PapTreatmentResponseField';
import PapSettingsField from './fields/PapSettingsField';
import ExaminationsField from './fields/ExaminationsField';
import WeightGainField from './fields/WeightGainField';
import IncludeDeceasedField from './fields/IncludeDeceasedField';
import SurgicalTreatmentField from './fields/SurgicalTreatmentField';
import SeizureTypeField from './fields/SeizureClassificationField';
import SyndromeField from './fields/SyndromeField';
import EtiologyField from './fields/EtiologyField';
import VNSTreatmentField from './fields/VNSTreatmentField';
import DBSTreatmentField from './fields/DBSTreatmentField';
import SeizureFrequencyField from './fields/SeizureFrequencyField';

/**
 * Extended search field component
 */
const ExtendedSearchField = ({
  platform,
  field,
  searchFields,
  logicalOperators,
  onChange,
  onChangeLogOp,
}: IExtendedSearchField): React.JSX.Element => {
  const value = searchFields[field.name as keyof typeof searchFields];

  switch (field.type) {
    case 'Custom': {
      switch (field.name) {
        case 'diagnosisDate':
          return <DateRangeField {...{ field, onChange, value }} />;
        case 'examinations':
          return <ExaminationsField {...{ searchFields, onChange }} />;
        case 'serologicalProfile':
          return <SerologicalProfileField {...{ searchFields, logicalOperators, onChange, onChangeLogOp }} />;
        case 'medication':
          return <MedicationField {...{ platform, searchFields, onChange }} />;
        case 'substance':
          return <SubstanceField {...{ platform, searchFields, onChange }} />;
        case 'relapseDuringLast12Months':
          return <RelapseField {...{ field, searchFields, onChange, value }} />;
        case 'currentLEDD':
          return <LeddField {...{ searchFields, onChange, value }} />;
        case 'treatment':
          return <TreatmentField {...{ searchFields, onChange, value }} />;
        case 'papDevice':
          return <PapDeviceField {...{ searchFields, onChange, value }} />;
        case 'papTreatmentResponse':
          return <PapTreatmentResponseField {...{ searchFields, onChange }} />;
        case 'papSettings':
          return <PapSettingsField {...{ searchFields, onChange }} />;
        case 'tirednessOrNearMissWhileDrivingDuringLast12Months':
          return <TirednessOrNearMissWhileDrivingField {...{ searchFields, onChange }} />;
        case 'weightGain':
          return <WeightGainField {...{ searchFields, onChange }} />;
        case 'includeDeceased':
          return <IncludeDeceasedField {...{ searchFields, onChange, value }} />;
        case 'surgicalTreatment':
          return <SurgicalTreatmentField {...{ searchFields, onChange }} />;
        case 'seizureClassification':
          return <SeizureTypeField {...{ searchFields, onChange }} />;
        case 'syndrome':
          return <SyndromeField {...{ searchFields, onChange }} />;
        case 'etiology':
          return <EtiologyField {...{ searchFields, onChange }} />;
        case 'seizureFrequency':
          return <SeizureFrequencyField {...{ searchFields, onChange }} />;
        case 'vnsTreatment':
          return <VNSTreatmentField {...{ searchFields, onChange }} />;
        case 'epilepsyDbsTreatment':
          return <DBSTreatmentField {...{ searchFields, onChange }} />;
      }
      break;
    }
    default: {
      return <DefaultField {...{ platform, searchFields, field, onChange, value }} />;
    }
  }
  return <></>;
};

export interface IExtendedSearchField extends Omit<IExtendedSearch, 'searchLoading'> {
  field: TESSearchField;
  onChange: (e: TOnChangeValues) => void;
  onChangeLogOp: (e: TOnChangeValues) => void;
}

export default ExtendedSearchField;
